import React from 'react';
import RadioSelect from 'components/pure/utils/form/RadioSelect';
import {FeedbackTriggerType, LibraryAccessType} from 'records/FeedbackTrigger';

export default class LibraryContextSelect extends React.Component {
  render() {
    const {selectedContextType, libraryOptions, selectedValue, tagOptions} = this.props;
    return (
      <div className="library-context-select">
        <ul>
          <li>
            <RadioSelect
              label="they added to any library"
              checked={selectedContextType === LibraryAccessType.ANY_LIBRARY}
              radioClick={() =>
                this.props.selectedContextTypeChanged(LibraryAccessType.ANY_LIBRARY)
              }
            />
          </li>
          <li>
            <RadioSelect
              label="they added to any library I* created"
              checked={selectedContextType === LibraryAccessType.LIBRARY_I_CREATED}
              radioClick={() =>
                this.props.selectedContextTypeChanged(LibraryAccessType.LIBRARY_I_CREATED)
              }
            />
          </li>
          <li>
            <RadioSelect
              label="they added to any library I* admin"
              checked={selectedContextType === LibraryAccessType.LIBRARY_I_ADMIN}
              radioClick={() =>
                this.props.selectedContextTypeChanged(LibraryAccessType.LIBRARY_I_ADMIN)
              }
            />
          </li>
          <li>
            <RadioSelect
              label="they added to any library I* can view"
              checked={selectedContextType === LibraryAccessType.LIBRARY_I_CAN_VIEW}
              radioClick={() =>
                this.props.selectedContextTypeChanged(LibraryAccessType.LIBRARY_I_CAN_VIEW)
              }
            />
          </li>
          <li>
            <RadioSelect
              label="they added to library:"
              checked={selectedContextType === FeedbackTriggerType.ADDS_TO_LIBRARY}
              options={libraryOptions}
              value={selectedValue}
              radioClick={() =>
                this.props.selectedContextTypeChanged(FeedbackTriggerType.ADDS_TO_LIBRARY)
              }
              valueChanged={this.props.selectedValueChanged}
            />
          </li>
          <li>
            <RadioSelect
              label="they tagged the call:"
              checked={selectedContextType === FeedbackTriggerType.LIBRARY_TAG}
              options={tagOptions}
              value={selectedValue}
              radioClick={() =>
                this.props.selectedContextTypeChanged(FeedbackTriggerType.LIBRARY_TAG)
              }
              valueChanged={this.props.selectedValueChanged}
            />
          </li>
        </ul>
        <div>
          * - "I" refers to either you, or anybody this rule is shared with who receives
          notifications
        </div>
      </div>
    );
  }
}
